import request from './request';

const messagesService = {
  /** All customer conversations (global admin). Query: limit, cursor */
  getAllConversations: (params) =>
    request.get('dashboard/admin/messages/all', { params }),
  /**
   * `{ total, waiting }` for the sidebar badge.
   *
   * The cheap counterpart to getAllConversations, which reads every thread and
   * its last message. `silent` keeps a failed background poll out of the
   * error toast — nobody asked for this request, so nobody should be
   * interrupted by it failing.
   */
  getConversationCounts: () =>
    request.get('dashboard/admin/messages/counts', { silent: true }),
  /** Full thread for one customer; marks user messages read */
  getThread: (userId) =>
    request.get(`dashboard/admin/messages/thread/${userId}`),
  /** multipart: userId, content?, subject?, attachment? (parentId ignored) */
  sendAdmin: (formData) =>
    request.post('dashboard/admin/messages/send', formData),
  /** Root = whole thread; reply = single message */
  deleteTicket: (id) =>
    request.delete(`dashboard/admin/messages/${id}/delete`),
};

export default messagesService;
